'use strict';

import angular from 'angular';
import result from './result.controller';

export default angular.module('bfastCaptureManagerApp.application.result', [])
  .controller('AppResultController', result)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/result/index.js